/** @format */

import React from "react";
import { useFieldStackSpacing } from "../fieldStackContext";
import ValidityCheck from "./validityCheck";

const TextAreaInput = ({
  id,
  placeholder,
  register,
  disabled,
  maxLength,
  errors,
  showValidIcon,
  tooltipText,
  onChange,
  onInput,
  ...props
}) => {
  const isInFieldStack = useFieldStackSpacing();

  return (
    <div
      className={`tw-group tw-relative tw-w-full ${isInFieldStack ? "" : "tw-mt-2.5"}`}
    >
      <textarea
        {...props}
        id={id}
        autoComplete="off"
        disabled={disabled}
        onChange={onChange}
        onInput={onInput}
        placeholder={placeholder}
        maxLength={maxLength}
        className={`tw-m-0 tw-box-border tw-block tw-min-h-24 tw-max-h-[125px] tw-w-full tw-resize-y tw-rounded-lg tw-border-0 tw-border-b-2 tw-border-solid ${errors ? "tw-border-dis-error tw-bg-dis-error-bg" : "tw-border-dis-field-edge tw-bg-dis-field hover:tw-bg-dis-field-hover"} tw-px-[15px] tw-py-3 tw-pr-10 tw-text-base tw-leading-[1.5] tw-text-dis-navy tw-outline-none tw-shadow-none tw-transition-colors focus:tw-outline-none focus:tw-shadow-none placeholder:tw-text-base placeholder:tw-text-dis-placeholder disabled:tw-cursor-not-allowed disabled:tw-opacity-60`}
        {...register}
      />
      {showValidIcon && <ValidityCheck className="tw-top-3 tw-my-0" />}
      {tooltipText && (
        <span className="tw-invisible tw-absolute tw-left-0 tw-top-[-44px] tw-z-[999] tw-w-[clamp(250px,90vw,413px)] tw-rounded-[11px] tw-bg-white tw-p-[7px] tw-text-gray-500 tw-opacity-0 tw-transition-opacity group-hover:tw-visible group-hover:tw-opacity-100">
          {tooltipText}
        </span>
      )}
    </div>
  );
};

export default TextAreaInput;
